import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentListCursor = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.listCursor,
)
